import * as React from 'react';
import {
  Edit,
  required,
  SimpleForm,
  TextInput,
  ImageInput,
  ImageField,
  maxLength,
} from 'react-admin';
import {makeStyles} from '@material-ui/core/styles';

export const styles = {
  inline: {display: 'inline-block', marginLeft: 32},
  margin: {marginLeft: 32, marginRight: 32},
};

const useStyles = makeStyles(styles);
const validateDescription = maxLength(10000);

const PreviewImage = ({record, source}) => {
  if (typeof record == 'string') {
    record = {
      [source]: record,
    };
  }
  return <ImageField record={record} source={source} />;
};

const NewsEdit = (props) => {
  const classes = useStyles();

  return (
    <Edit {...props}>
      <SimpleForm>
        <TextInput
          source='title'
          validate={required()}
          formClassName={classes.inline}
        />
        <TextInput
          source='description'
          multiline
          resettable
          fullWidth
          validate={validateDescription}
          formClassName={classes.margin}
        />
        <ImageInput source='imgUrl' label='Image' accept='image/*'>
          <PreviewImage source='imgUrl' />
        </ImageInput>
      </SimpleForm>
    </Edit>
  );
};

export default NewsEdit;
